import defaults from "nodemon/lib/config/defaults";
import React, { useEffect, useState } from 'react';
import {useHistory} from 'react-router-dom';
import axios from 'axios';

let allcorporate=[]
const SelectSchemeReport = (props) =>{
 let history=useHistory()
   let [scheme, setscheme]=useState([])
 let [call_log_user, setget_call_log_user]=useState({})
let [selected_scheme, setselected_sceme]=useState('')
// console.log('dkmksmks',props)
    const fetscallScheme=()=>{
        console.log('testin============g',props.useserdetails.id)
        axios.get('/get_schemes_stamp_paper?user_id='+props.useserdetails?.id).then((res)=>{
          console.log(res,'teesting============2')
          allcorporate=[]
          if(Array.isArray(res.data.data)){
            res.data.data.forEach(key=>{
              if(JSON.parse(key.id)===JSON.parse(props.useserdetails?.corporate_id)){
                setselected_sceme(key.id)
              }
            })
            for(let i=0;i<props.useserdetails.corporate.length;i++){
              res.data.data.forEach(key=>{
                if(props.useserdetails.corporate[i].toLowerCase()===key.scheme_name.toLowerCase()){                  allcorporate.push({id:key.id, scheme_name:key.scheme_name, payment_mode:key.payment_mode})
                }
              })
            }
          }
          setscheme(res.data.data)
        })
      }
    
//       console.log('props.useserdetails.roles', props.userRole)
      const get_call_log_user=()=>{
        axios.get('/get_call_log_user?user_id='+props.useserdetails.id).then((res)=>{
          if(res.data){
            if(res.data.length!==0){
              setget_call_log_user(res.data[0])
            }
          }
        })
      }

// console.log('call_log_user',allcorporate, selected_scheme)     
//   ?
//       console.log('props.useserdetails.corporate_id',props.useserdetails.id,'testing', props.useserdetails.corporate_id)
   

    return(
        <>
        <div>
            <select value={selected_scheme} onChange={(scheme_sele=>{
        console.log(scheme_sele.target.value)
        axios.get('/update_scheme?corporate_id='+scheme_sele.target.value).then(res=>{
          console.log('updated')
          history.go(0)
        })
      })}>
        <option key='-1' value="" disabled>Selected Scheme</option>
        {Array.isArray(props.useserdetails?.corporate)&&
          allcorporate.map((schemeval, i)=>{
        return(
             <option key={i} value={schemeval?.id}>{schemeval.scheme_name}</option>
              )
        }
        )  
        }
        
        </select>
    </div>
        </>
    )
}
export default SelectSchemeReport;